<template>
  <div>
    <h1>{{ header }}</h1>
    {{ dateRangeText }}
    <!-- Toggle between blocks and numbers/grid -->
    <!-- Toggle between calendar week and running week -->
    <!-- Toggle between blocks earned each day and cumulative -->
    <!-- By day vs by category -->

    <!-- TODO - Highlight current block -->
    <!-- TODO - Convert to blow-row with mouseover and interactions for each? This works for both category and weekday views -->
    <static-block-row class="weekProgress" :completed="daysCompleted" :quota="week.length" color="white" />
    <!-- FIXME - Better positioning, please! -->
    <div class="displayTypeToggle">
      <input type="radio" id="cumulative" v-model="display" value="cumulative" />
      <label for="cumulative">
        <i class="material-icons action-icon" title="Cumulative">
          view_day
        </i>
      </label>
      <input type="radio" id="daily" v-model="display" value="daily" />
      <label for="daily">
        <i class="material-icons action-icon" title="Daily">
          view_week
        </i>
      </label>
      <!-- FIXME - We might be able to use view column/week and view day Google Icons here -->
    </div>

    <cumulative-week-view v-if="display == 'cumulative'" class="categorySummary" :categories="categories" />

    <daily-week-view v-if="display == 'daily'" class="daily" :categories="categories" />
  </div>
</template>

<script>
// TODO - Set default view for each user
// TODO - Support past weeks

import CumulativeWeekView from "../views/CumulativeWeekView.vue";
import DailyWeekView from "../views/DailyWeekView.vue";
import StaticBlockRow from "../components/StaticBlockRow.vue";

import util from "../util.js";
import db from "../db.js";

export default {
  name: "week-view",
  components: {
    "cumulative-week-view": CumulativeWeekView,
    "daily-week-view": DailyWeekView,
    "static-block-row": StaticBlockRow,
  },
  props: ["categories"],
  data() {
    return {
      display: "cumulative", //FIXME - Set this from route parameter
    };
  },
  created() {
    //Load data for the previous days if it doesn't already exist
    // db.loadPast7Days();
    // db.getWeekSummaries(); - Add route date
  },
  computed: {
    header() {
      let date = this.$route.params.week;
      // FIXME - Add formatting for other weeks
      return date ? date : "This Week";
    },
    week() {
      return util.getCurrentWeek();
    },
    //TODO - eventually we will want to localize this
    dateRangeText() {
      const start = moment(this.week[0], util.dateString);
      const end = moment(this.week[this.week.length - 1], util.dateString);

      if (start.month() != end.month()) {
        return start.format("MMMM Do") + " - " + end.format("MMMM Do, YYYY");
      }

      return start.format("MMMM Do") + "-" + end.format("Do, YYYY");
    },
    // Return the number of days of the week that have been completed
    // TODO - Check math here, please!
    daysCompleted() {
      const start = moment(this.week[0], util.dateString);
      return Math.min(moment(util.getCurrentDay(), util.dateString).diff(start, "days") + 1, 7);
    },
    summaries() {
      let summaries = {};

      for (let categoryId in this.categories) {
        const category = this.categories[categoryId];
        const quota = category.quota * (category.activeDays ? category.activeDays : []).length;
        let completed = Object.keys(category.blocks ? category.blocks : []).length;

        this.week.forEach(day => {
          completed += category.days[day] ? category.days[day] : 0;
        });

        summaries[categoryId] = {
          completed,
          quota,
        };
        //TODO - Individual days
      }

      return summaries;
    },
  },
};
</script>

<style>
.weekProgress.flexRow.blockRow > div.block {
  height: 0.75rem;
  width: 0.75rem;
}

.weekProgress.flexRow.blockRow > div.block.last {
  height: 1.25rem;
  width: 1.25rem;
}

.flexRow.categoryRow .blockRow {
  max-width: 100px;
}
</style>

<style scoped>
.weekProgress.flexRow {
  align-items: center;
}

input[type="radio"] {
  display: none;
}

label {
  color: #ccc;
}

input[type="radio"]:checked + label {
  color: #3498db;
}

.weekday {
  width: 150px;
}

.flexRow {
  align-items: baseline;
}

.weekProgress.flexRow {
  justify-content: center;
}

.displayTypeToggle {
  margin-bottom: 0.5rem;
  padding-bottom: 0.25rem;
  max-width: 1100px; /* FIXME - Normalize on our centering strategy */
  border-bottom: 1px solid #eee;
  margin: auto;
}

.categorySummary {
  max-width: 800px;
  margin: auto;
}

h1 + .categorySummary {
  margin-top: 0.5rem;
}

.categoryStats {
  font-size: 0.875rem;
  margin-right: 0.375rem;
}

.categoryInfo {
  width: 150px;
  text-align: right;
  padding-right: 0.75rem;
  border-right: 1px solid #ddd;
}

.staticBlockRow {
  max-width: 600px;
}

.daily {
  max-width: 1100px;
  margin: auto;
}

.daily .blockRow {
  padding: 0.5rem;
  /*justify-content: space-around;*/
}

@media (max-width: 600px) {
  .displayTypeToggle {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// WeekView.vue?ce7dc3b2